module.exports = __webpack_public_path__ + "img/bg-image-16.0f451b50.png";